import React from "react";

type PrizeLabelStatusProps = {
  label: string;
  className?: string;
};

const PrizeLabelStatus = ({ label, className }: PrizeLabelStatusProps) => {
  return (
    <div
      className={`inline-flex min-h-4 lg:min-h-5 justify-center items-center rounded-[5px_0_5px_0] bg-primary text-white px-2.5 py-0.5 lg:px-3 ${className ? className : ""}`}>
      <span className={"text-white font-jost text-[10px] font-semibold leading-3 lg:text-[13px] lg:leading-[18px]"}>
        {label}
      </span>
    </div>
  );
};

export default PrizeLabelStatus;
